import React from 'react';

import { useGQLLocale } from 'corgi/common/hooks/locale';

import errorStatic from '@static/error-page.json';
import ErrorPageStyles from '../ErrorPageStyles';
import TraceId from '../TraceId';

const ErrorBody = () => {
  const locale = useGQLLocale() as keyof typeof errorStatic;
  const { title, subTitle } = errorStatic[locale];

  return (
    <>
      <ErrorPageStyles />
      <section id="error">
        <h1>{title}</h1>
        <p>{subTitle}</p>
        <TraceId />
      </section>
    </>
  );
};

export default ErrorBody;
